var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.96 218.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.35,48.3l-4.69-39.84s-2.34-16.4-9.37,0-4.69,46.87-9.37,65.62c-4.69,18.75-9.37,58.59-9.37,58.59,0,0-7.03,11.72-7.03,21.09,0,9.37-7.5,59.16,0,60.93,7.5,1.77,46.87,2.34,49.21,2.34s7.03,0,7.03-14.06c0-14.06,2.34-30.46,0-37.5s-2.34-18.75-4.69-25.78-14.06-77.33-11.72-91.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.72,144.38s-14.06-9.37-21.09-9.37c-5.27,0-15.82,3.95-20.76,6.92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth09);
export default __webpack_public_path__ + "static/media/tooth-09.b356e67432aaa19dbdebb2029bbc6706.svg";
export { ForwardRef as ReactComponent };